import { PulsatingBorderHighlight } from "./PulsatingBorderHighlight";
import { BackdropHighlight } from "./BackdropHighlight";
import { ElementPointer } from "./ElementPointer";
import { TargetElementHighlightStyle } from "@common/schemas/v2";

export interface ElementHighlighterProps {
  target: Element;
  higlightType: TargetElementHighlightStyle;
}

export function ElementHighlighter({ target, higlightType }: ElementHighlighterProps) {
  if (higlightType === "pulsingBorder") {
    return (
      <>
        <PulsatingBorderHighlight target={target} />
      </>
    );
  }

  if (higlightType === "backdrop") {
    return (
      <>
        <BackdropHighlight target={target} />
      </>
    );
  }

  return (
    <>
      <ElementPointer target={target} />
    </>
  );
}
